import * as Sentry from '@sentry/angular';
import {
  APP_INITIALIZER,
  ErrorHandler,
  enableProdMode,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { HttpInterceptorFns } from './app/common/interceptors';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AppRoutingModule } from './app/app-routing.module';

// @todo: Make Sentry environment specific.
Sentry.init({
  dsn: environment.sentry.dsn,
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: environment.sentry.tracesSampleRate,
  tracePropagationTargets: environment.sentry.tracePropagationTargets,
  replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
  replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      MatSidenavModule,
      RecaptchaV3Module,
    ),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors(HttpInterceptorFns),
      withInterceptorsFromDi()
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideStore(),
    provideEffects(),
    isDevMode() ? provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }) : [],
  ],
}).catch((err) => console.error(err));
